exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ant-modal-title {\n  text-align: left;\n  font-weight: 600;\n  font-size: 1.25rem;\n  letter-spacing: 0.064rem;\n  color: #0F172A;\n  opacity: 1;\n}\n", ""]);

